import { ALLOWED_ORIGIN_PATTERNS } from '../constants';

export const isOriginAllowed = (origin: string): boolean => {
  return ALLOWED_ORIGIN_PATTERNS.some((pattern) => {
    if (typeof pattern === 'string') {
      return origin === pattern;
    }
    return pattern.test(origin);
  });
};
